import { render, staticRenderFns } from "./WidgetCategoryReviewsHorizontalScrollMobile.vue?vue&type=template&id=f8828e52"
import script from "./WidgetCategoryReviewsHorizontalScrollMobile.vue?vue&type=script&lang=js"
export * from "./WidgetCategoryReviewsHorizontalScrollMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports